// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get, isEmpty, lowerCase, pick, startCase} from 'lodash';

// Components
import TableWithSort from '../core/table-with-sort';
import Button from '../core/button';

// Containers
import FormData from '../../containers/form-data';

// Styles
import './flag-metadata-issues.scss';

const formName = 'flagMetadataIssues';

function FlagMetadataIssues({flaggedMetadataDeleteIssue, setIssueFormValues}) {
    const getColumnConfig = () => [
        {
            dataKey: 'fieldName',
            formatter: ({fieldName}) => startCase(fieldName),
            title: 'Field',
            width: '25%',
        },
        {
            dataKey: 'issueType',
            formatter: ({issueType}) => startCase(lowerCase(issueType)),
            title: 'Type',
            width: '10%',
        },
        {
            dataKey: 'comment',
            title: 'Comment',
            width: '45%',
        },
        {
            dataKey: 'issueId',
            type: 'component',
            component: Button,
            componentProps: getButtonProps,
            title: '',
            tooltip: 'Delete',
            width: '15%',
        },
    ];

    const handleRowClick = (_event, dataRow) =>
        setIssueFormValues(pick(dataRow, ['fieldName', 'issueType', 'comment']));

    const getRowDetails = () => ({
        onClick: handleRowClick,
        whitelistKeys: [
            'comment',
            'createdBy',
            'dateCreated',
            'fieldName',
            'flaggedMetadataId',
            'issueId',
            'issueType',
            'lastModifiedBy',
            'lastUpdated',
            'version',
        ],
    });

    const getButtonProps = (dataRow, {dataKey} = {}) => ({
        children: 'Delete',
        className: 'flag-metadata-issues--button',
        onClick: (event) => {
            event.stopPropagation();

            return flaggedMetadataDeleteIssue(get(dataRow, dataKey));
        },
    });

    return (
        <div className="flag-metadata-issues">
            <FormData formName={formName}>
                {({formData}) => {
                    const issues = get(formData, 'values.issues');

                    return !isEmpty(issues) ? (
                        <TableWithSort
                            className="flag-metadata-issues--table"
                            columnConfig={getColumnConfig()}
                            localSort={true}
                            notSortable={['issueId']}
                            rowDetails={getRowDetails()}
                            searchData={issues}
                        />
                    ) : null;
                }}
            </FormData>
        </div>
    );
}

FlagMetadataIssues.propTypes = {
    flaggedMetadataDeleteIssue: PropTypes.func.isRequired,
    setIssueFormValues: PropTypes.func.isRequired,
};

export default FlagMetadataIssues;
